import * as React from 'react';
import classNames from 'classnames';
import { inputContent } from '../../../content/content';
import renderDataTest from '../../../utilities/testAutomation';

interface TextInputProps {
  error?: string | false;
  addon?: Addon;
  hideAddon?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<any>) => void;
  dataTest?: string;
}

export enum Addon {
  Pound = '£',
  Percentage = '%',
}

const parseDecimals = (value: string) => {
  if (/^\d+\.{0,1}\d{0,2}?$/.test(value)) {
    return value;
  }
  return (Math.trunc(Number(value) * 100) / 100) || value;
};

const TextInput = ({
  error,
  addon,
  onChange,
  hideAddon,
  placeholder,
  disabled,
  dataTest,
  ...rest
}: TextInputProps) => (
  <div className={classNames('input-wrapper', { 'has-error': !!error })}>
    <div className="input text-input">
      <div className={classNames('addon-wrapper', { 'no-addon': hideAddon })}>
        <input
          type="number"
          {...rest}
          placeholder={placeholder || inputContent.textInputPlaceholder}
          min="0"
          disabled={disabled}
          onChange={(e: React.ChangeEvent<any>) => {
            const { value } = e.target;
            e.target.value = parseDecimals(value);
            onChange(e);
          }}
          {...dataTest && renderDataTest(dataTest)}
        />
        {!hideAddon && <span className="addon">{addon || '£'}</span>}
      </div>
      {!disabled && <div className="error-text" {...dataTest && renderDataTest(dataTest, 'error')}>{error}</div>}
    </div>
  </div>
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/TextInput/TextInput.tsx